// @flow

import { Map, List, fromJS } from 'immutable';

export const GET_SEARCH_RESULTS = 'App/search/GET_SEARCH_RESULTS';
export const GET_SEARCH_RESULTS_SUCCESS = 'App/search/GET_SEARCH_RESULTS_SUCCESS';
export const GET_SEARCH_RESULTS_FAIL = 'App/search/GET_SEARCH_RESULTS_FAIL';
export const CLEAR_SEARCH_RESULTS = 'App/search/CLEAR_SEARCH_RESULTS';

const initialState = Map({
  getSearchResultsLoading: false,
  searchResultsList: List([]),
  getSearchResultsFail: null,
  searchedQuery: null,
});

export default (state : any = initialState, action : any = {}) => {
  switch (action.type) {
    case GET_SEARCH_RESULTS:
      return state.merge({
        getSearchResultsLoading: true,
        getSearchResultsFail: null,
      });
    case GET_SEARCH_RESULTS_SUCCESS:
      return state.merge({
        getSearchResultsLoading: false,
        searchResultsList: fromJS(action.data.list),
        searchedQuery: action.data.query,
      });
    case GET_SEARCH_RESULTS_FAIL:
      return state.merge({
        getSearchResultsLoading: false,
        getSearchResultsFail: fromJS(action.data),
      });
    case CLEAR_SEARCH_RESULTS:
      return state.merge({
        getSearchResultsLoading: false,
        searchResultsList: List([]),
        getSearchResultsFail: null,
        searchedQuery: null,
      });
    default:
      return state;
  }
};

export const getSearchResults = (data : string) => (dispatch : any) =>
  dispatch({ type: GET_SEARCH_RESULTS, data });

export const clearSearchResults = () => ({ type: CLEAR_SEARCH_RESULTS });
